/**
 * Targeted Announcement Wallets Configuration
 *
 * This file contains a list of wallet addresses that should see the
 * "wallet connected" message in the announcement banner.
 *
 * Usage:
 * - Use "*" or "all" to target ALL connected wallets
 * - Add specific wallet addresses in the format: "0x<address>" to target only those wallets
 * - Only wallets in this list will see the connectedMessage when they connect
 * - All other connected wallets will see the notConnectedMessage instead
 *
 * Examples:
 *
 * // Show connectedMessage to ALL connected wallets
 * export const TARGETED_ANNOUNCEMENT_WALLETS = ["*"];
 *
 * // Show connectedMessage to ALL connected wallets (alternative)
 * export const TARGETED_ANNOUNCEMENT_WALLETS = ["all"];
 *
 * // Show connectedMessage to specific wallets only
 * export const TARGETED_ANNOUNCEMENT_WALLETS = [
 *   "0x1234567890abcdef1234567890abcdef12345678",
 *   "0xfedcba0987654321fedcba0987654321fedcba09",
 * ];
 */

export const TARGETED_ANNOUNCEMENT_WALLETS: string[] = [
  // Add targeted wallet addresses here
  // Use "*" or "all" to target all connected wallets
  "0x0025403677cae9478a7b61c4f8b0d72620ef94dac8305c1e5566a8f6a952ba53",
"0x00a8afc41376d3e7f2913e446bb13e9415f4f38f3069da639caeae4417bb445a",
"0x03b7a500004ba20d01282ed580545346c1d7ac9fb1cf9e0be744b42942c6bb4a",
"0x042052581fd60d4c5190de49e86bf0b0c029902afdde03cdce0f1f464afa4135",
"0x065c092269b01b58e68ab8c5c06100e3af03048ba7d144bc76f119fc9944dcd4",
"0x0677256e1b19d0a6e5445d3cbb4b894a6d736e8770c47307f4c108badcc718ad",
"0x07f893c6648584d92ed806df37bb3ce79a969edf067b0ff7208ed4b40ed18497",
"0x08f21641e76426925aa21415ab0a6795fd828c148d26e5a5aa3a7bac259a5ab4",
"0x093f6f924e8355d66f3210961e3de4b7cd18334ee7f3adcdbf0843f115350b99",
"0x09fced38acf44f63b1da1e3165bac2beeac3940887fcadff39c058a80fc89f20",
"0x0a9748b5bd49f612c4e648b408113cd5b794710f4a901b306fc519a056cd6229",
"0x0b4e7e68896a165cbe16fa425e92fb31f01bc7f2973c9bae673c157fd02d5945",
"0x0bd8cd6905623185d3bd8a2ec03c803d68507dddfdc42f8effc98ccd21b36d7b",
"0x0dfd4d0187beedf79100fdff899151e4b33dcca1c5d1623026a2552ed93847e9",
"0x0fd10341ec3d2243c05b272799a404688272a1e569b59e583b7b4c756604e56b",
"0x10616493e1430869425185c65fc731b6229cefb8cc4ea154a45bb6b9e4a8bc0e",
"0x1333891ec516f2f57d9a71d3b2602ae7889c70e388f304a8058c86b225c7fb87",
"0x1352266c438cf155eba0422b9a33e3e8149145ed7cde91c08d4526c0b496b5f6",
"0x13f88933f1afa3eb9d4fd1f7b6106bb53e2b7e8afb7335d4b872fcc178f222d3",
"0x140f9dfd53ade2c598785ed158d09dc0f8436a4212d8fd9144a35cbdbbff1e2e",
"0x1490fa20c782b8ad0182d340ab9f7b7a3bcdcd5048c02c8dd44ad1e2d7e7fcc0",
"0x1530151c80a6c504673387d5d6ef6a813897d61245c671bfa4cdd849f3a592ec",
"0x15ff2314101bf0b79ef77d16378c53b97d4e002ea1f3014b995bf44cb8dcd6ce",
"0x169ed4c80feff2d05a820cf7c146a45d152b2e1f045767946074dce9e7481d02",
"0x1855ac70b3ce35f76f7a5c724cede2e41e9c8ed47b9353adf5bdc8954eea8dfa",
"0x1a600db3a5ffe76a8bf11d30b74fdec5963dd9652c2e9d8e6a3777f10d9efcb1",
"0x1c0432744b53edaf7003f24fa928b8356493a1f8bccf2aed1ffff87e1b4599f3",
"0x1c4107e1e5464080fecdc38b45074f00ce55167a6dcce7020bb2ec4ff702a3d9",
"0x1d43e4cfb2dda54d70e1d5eed9adf50f0d2715aa130ba3a9d6c9657ef9cb8b9e",
"0x1de58c9759c43c92847069dc5457beb4c1168e9fa2c0449d39bc39b1467f842a",
"0x22fa7fbae287af83b2eede613e234f2fae20499207fdef01d5f7caa425424078",
"0x23668374283e9287b4f117b94ed2d6d2c7b729bbb2bc53842821e0521830bf88",
"0x24476d4eea13ccda0dacc01423050adba0b51e6c35f17598fa61fbe42a410949",
"0x24511cfae38ef18efff604358376dff992d9e9f7e9cfee46aba37a1dd9c740e8",
"0x26a5c9de332d83df86c10a6beced9612fc8576fa44d78b644506e8861103d11e",
"0x29c77c5e541bb63d517d635d2cb50b45e0ec6d12056362f631ce3ca88daabcdc",
"0x29ca24713e2df04921c7541bcc3a4c3e74324cd5fd69f47b10019cc0a9ec3de4",
"0x2a8b917d93dffdbf75c652f17a201dafc10cac7ab996eb92d73a28ede1842cf4",
"0x2b770dfa31a7d0e50c71c61eb825a7c75e971c51a999aee5fcac5fc2ee9e8a92",
"0x2c90793c0389234ce7008ec2fa77ab66ad4954ada6039b9848051c12ac2edf94",
"0x2da4d13e0743f2b10c4a5a5a72333962d6fce4ce2e99699cc7f30aa1c7295535",
"0x2ee7eec203d6fd2412fa3839363d49aadbbd265fcead47044f2dfd9087df0db7",
"0x2f4a2e7ada45275ec815df889c9f778da79baaaa1d9a6344f66ed3f17404def2",
"0x2fb92c79fc055fdf376311ecd46d46b847ad3ac9b6394b8aa54858d04c56e5bd",
"0x2fbf468bc6d6227457c342a747d6622e81a80de40f854a90bfde61f4da5d1aa8",
"0x2fe826d55a3041b3539d492340667c422b3ebd056684608730371104eb93bf97",
"0x2feb62b5ac6ebf9e411f6b8eef7cc67a373ac822307c9f6263d12bfd4e266b8f",
"0x3005eed4be5524eb6b1413136f72b10877772ba8db6c341bec2029d545dca21f",
"0x302f41d02dac28d37d2f9daa0ecf2195d16f4abdbc9ae5fbd198cd4ac70a63a1",
"0x3062f2c5e0fa62e3d0b91fd49cb763499e059415e56164529339fcc4234cb356",
"0x32ce92ccafbb67d4f3ab2aaa8ac452b319a0bbe3b0befd437b19117f91300f4e",
"0x3b856740705990856d32b4e62177d5525c54c2132a54d9ee9b727fbd50fe8a7e",
"0x3dcf24fd746de2b0182b3d2d1e3608cd722dc4efb33f4861adb9efa23cbad2dd",
"0x3ed69e4a22f7a78ceb3251edcad9edcf74189b6005a54c5e969c1819dfcec12e",
"0x3ed71b4ffd6d90d3b24ad9f7c208d8045f753c894c4e36c2ffd81b536546ffb8",
"0x412eee57689a2e975a40e714b032363b6d7c0bfe1a3532aa27ce6f674369c556",
"0x418278318182b987323cff9d01dd7b3711361d3294d605b65faf7d5deadf6848",
"0x41ee1beb5b90b137d5bb34927f5bda4cae3c7fb4827b0053be60838633fd0329",
"0x42ac152ee7ff9d095198a403e38fe13dc3e8569ef16d56b1f4771789969e2b2c",
"0x42b9e6083aac52cbd23b84bc72db8189f4c94b4c86c8e4910e81b2b548cfeca8",
"0x42d20c941fedb80264538421732b25476ce2733a0fe164a70c2ba68e514970ff",
"0x43077951fb89c368d10bad54cdd6792d6e84b07b11023af3e962aa0d223d52bf",
"0x4386a003e768bcf35ef05eaab4fa2f5a62b2e0b3f645f84154d8e5622b2665d5",
"0x43d08c4a0182de8a0b6b31bf3b948b9ba5827415e924369f2b17a3c66c2d6641",
"0x441f65a85684497718c13033ef4aa15c815748a07582fd4187a432b56df9f940",
"0x473873a543443f210b08c3d78050ecf7df6081224caeb61827a4de466dd01073",
"0x474143654d8de94738232041069e83f956c609d92ec895af27a6d05634e20e5f",
"0x47f83c6e3f1ee7ee2c83ad82a40bd975dea25db7b2b80e12a317f29e0838d4fe",
"0x4a9943dcf5117ec353537777f0d2b8d790f4f74c2d6a344b0eff46d5075d343f",
"0x4c1812748c5f94114d8b7ad90f7dd1416b7b1988ba92db48edaa3ed51e66a38c",
"0x4de95c1a1a3eca1612f59d3e14b0242399867960ef21ec80a711ec8a2c833a5b",
"0x5056bf59c7964cb3dea7cd295495a14dddfef7b38970166b3ee1bd4879056840",
"0x50f39ede73a457c6a80cf6cc5821bfbcd11a361052559fc3ce3c0d08386188df",
"0x51069720755923e246f127cb968eb0b7bc868138284d41e52995eaf04b2af549",
"0x510df7fbf82a5e8654dda5921ee8e71a86ded5fad760dfb5a12b446ca8807966",
"0x521bf46116eda338afb95274c67c1d5e2638fcd80533e1c1fb2eabba3b9f5a7f",
"0x529b26c8cc716f9e427e28d2bc84d111e4d8854fc00cbabdf0e480a3a40d3be0",
"0x54329140356f7f8580dc083eb85b9b159dbc3c7a8fabdbbfb5837f72ddeadf4c",
"0x546c6d5279dd8aae9feb589cfcc47157b54542e9ef5664ccb1ec7832b723d4c2",
"0x55a5e526b3f326cd5c459949b86b55ce0beb7c1a3a31fbb6b0cccd5bbe4f84ee",
"0x56c60877b2be836e6f4b1b59ef7249be2af677db5322dca0de3d73f79b226cfe",
"0x57632f2711990e5b5096e7c3fb7813858e42a83ad25773ffe14cf08abe738a45",
"0x5803e89bdca095870d53bb2b6af77fbef7c2cadd24cfe084f11fe363bfc8dc59", // mine
"0x5902c832d3d6b39d2e5bfdd5d80ddd3b74aeca529bb9deb81b1ff96333ad7560",
"0x59c28ad606b3aacea403153128ff4894a38b14d9eab83535fa07bc8cd638830d",
"0x5bac424c001c1c9b526436aec79d5c40202592345a01eaee32f7167feb355340",
"0x5c9da12775a006a1f42a4c71e7aa6ff0b3b9cc06f058bb9a673156388e24938b",
"0x613304654d7071022e44fb98ba83bbb95f552c95739579f88d367f1d576867d5",
"0x615f7f17c0d4141bf14108c8ef10974ad4db3108d34921516048c03b56ba9e5c",
"0x620f923774bd7dce97cb2ca9418bd2c91afb32c3c741a3ce1bddd063cc71cce0",
"0x64bc2b8d03180a675f3349ff3dc237f7c61ac92d41472df067584c4f269192fb",
"0x666f08e099313d7fcb78f10489b073f1277d4d88559a68c1f522cdb7b0888309",
"0x681831c2c39c1f85b14bfc844ce6798e35623e2cefd4444f80ca8cf60b042d7d",
"0x6ade7c16f7fb40e2c7c8db63fa2ce930ea981dc5efef5bb00ed3076d4900c02c",
"0x6c07de171adb24d37ab7399427a7fb555e2ebe91050772049cbf7a68e530b5df",
"0x6c38370821e59f6c3b73bc6c2847d4738e8fd8b909e14ba009b9ee0791c22f1a",
"0x6c88e5345c561602ff5080deeb08e04c9a74ffae7b05b671d5c6941aea852048",
"0x6d24cdd1f390ff34ae9f8ff6d58e006a9e3fb53b1f3667a747e84be4f5e565ca",
"0x6d3585196522b1573509f599b2dba5244d5feaf3fef71f3b99a4ca4e7728eb34",
"0x6da2e438bb552e93a0de17be467a94c94527b078e32f34cc373e09da68f39b21",
"0x7161a1af0bf1b951046090d5a1a30e6985e66931d391270b11f080b6566e8d32",
"0x75109e1512c353d2be1f70438984a5def864bd4ff9858d778fb553b9b057308b",
"0x757db76da7919e94766a620859da1acf18129c5c4bb455aa7a2ae77dc9e31c17",
"0x75dbd3df982fc59573e175581ba41d9571add9763d3967d1a6e7d0cef0aa00dc",
"0x77729fb25ebd9b256976558301d247593bfad47a5cf576771a3baa08ad4ce6c0",
"0x78fdc855a8772b32f8b626b7dad4ef3db6607a7b6d1cc69598d7aaaa343a64b5",
"0x79241ceeec6e639e2c6e068f08bc64c7d9382c90257bdc81d3c19b4b01010729",
"0x792ab56149f38026e527e21d9df34cfde42755f37b9292481861bfadea1ec1ee",
"0x7c59885cad49691c6ef3efd6aa745913191ee5c781796c5358130c2767bd6748",
"0x7d87795b2ae09aa771b00dabfefa15d089ddd7803b128ccd03ed5a8d4eb2845e",
"0x7da21d35ec613b6feac71d2e612bdacd6338b1d6668a31e9fd5e0adf3763273a",
"0x7de58807d920205c8168f95100292497e765d557fbc86290ee441ae1b6c268a1",
"0x7e0f1e5fdbac6b7ca0739ba834d4aa6093e174a6167c6171f2fc430549115f13",
"0x7e7bd6bbd08b4760a185bf24086cee7d140899067bd3b550edc35f20f35ac7f9",
"0x7ef24ab8c26fba6f3264e4a1a2cc1022501e3853f97c482b5113c944104e7038",
"0x8060990fb9fef7a79232928c2666c5c316bc31fcd4efbdbc65c3cd7646d13928",
"0x83bb32346ff251457dea8c14bdaa4f83122cd1af8c9b504f2503de6ceec96904",
"0x83e83b879809065c55ee9144b8cdecf1f1034374de5e140481d23e9aceabe414",
"0x841db08ab008f7826467f4788cdd6474ea2de950e58a305d0c19fbc0ecfef295",
"0x844d01fbc7c68db2cc04f94a2d04dc702597a2506a4786f59632e8a62e287323",
"0x854d9dde869c731aa7801b70493344c5f27b5f45e6ce79b2337a3a7b23526cb6",
"0x85fff6034b02fd896d9d1c34dac8464bcfef3ecaa95bf4471bf99cfc099b3594",
"0x8674906234a6666a0097d0668769ca08cc3581eb4cfff31be4491de923c8dd21",
"0x8684402e2f84c8a23219373b26af3756517306912aee30bf210972046def3095",
"0x86d82c2e196b5dc28b7f5fc6539c5feac73c22e9975785c71f6b17be939ad0b1",
"0x8701d470a00787c56853ad77661045f6100e456aafbe0f8e5d92302be6777541",
"0x8b56a8f74638de1c27846dea3af52ea5af1fe787376f117a908eb966cc37a451",
"0x8d9ee12e9a024a771e2e8d26b929cb954ea709da040f275ab263b50de3a5b6bc",
"0x8e112b4b95fb7581024cfea0522b5688caa9fafc1ad10165cb42b9107d27ecf2",
"0x8e99b39cd840056ae80e7419932fd60c1b61bf4a9a0edc0ca0139af7b18fb6d8",
"0x8ef0bf0b3da599a0c725e29e727b6f9b756f4d20717da3be7a92c674a88a9020",
"0x90c6b7e857910e0fb869a424fea4695d89f1f84a7bfd1e7745b7eabd1e61c2d2",
"0x91661c269f176220036fc3506fc759f700b7640755b445740085b5b081db5e0d",
"0x926d6ec8cba508f4a57febf69ef555298f51ca1382624d7d969ccc4ec002bead",
"0x9299f4420fc8dfaa410460cd851f6a022740f450f34d2ad794619b64e5048f80",
"0x93e387067b82258d3e7f51cc4c6aef823955595f9a6d1b800eda1ee489afcbe4",
"0x977f6b3c337c962ff758dcfa6479e10f7642f216253d264ee62c88293db29c6e",
"0x97cea2dc24004fa6e45f7d1d18cc4b8aacaa5b1ed0381527889950b24728053e",
"0x97d41ad7dad258d5ddc55f3c894ff828cf695241ace13906772ddb53ff4dde90",
"0x98bd0f022afe547555e8a54083159df7863c7272bf626a3a029b652e2bca8496",
"0x995a66dc8813bc62780209a7f6b18657cf9e04107c38289b5ab4c990fd36d34a",
"0x9a95dea57d9408d675ce8928bd2875913180b09ab5285ef8371e0053b610bcb2",
"0x9aa1563409107ac6fc5ed3eca95891ad686ed195fbd06e05dd46560bece2f7ee",
"0x9ba84a64ff1a17c208116b5b834defac21d89c05c4cfea72baaa256d6e7976df",
"0x9ddb9e5b967c8cbc7ab1135e78b67e8be708813f31365c00c1e423b6e3999ebd",
"0x9f15ae85c229c666939ef9cb867b2142cb31608f9abb77dc0c705809b64c9311",
"0x9f986aa5b1de4e0e35d6b3bc87b5a8c50f3647ed6c1932d032b6bde822e3d0aa",
"0xa14e1b0d70c339c9b48c4aa68c35668228b577c05de12bed52179c5467794e0f",
"0xa20e4edc0a46936f5806fc5ee6080f2eb30883818d4e93021183d551b86acbf1",
"0xa323a2dec22e8c3df16ed7f254f64a106f22532551bc436aeaf61a4df2013366",
"0xa3bfbc3f76879e37b48c152918dfb717f72f901238d64469f5cb332a344c8522",
"0xa4437982b22f49eedfc9721133ece7cdbdc2defb12c4462af8e1ccda4a67eade",
"0xa50f74f14d3a6bfa9dd2e00e948a788728b3ca5419684d758c7f5d7139b43a5e",
"0xa5662c3a8efc3f7c20f2d2cd83913a08bfb21e9777800772d7f753cdd60b5706",
"0xa578d213604ff69daa7b3699c5ba28dbbf018bb67850c32b5596d60253cdeadf",
"0xa5c71a6ad7aa09b3eecd2cef6ba6b6f984c39bcc29cb01e2324f3461d182963a",
"0xa6121a175c7f62d91e4eababbea1b5451866829635c84373e5da2a00666bb298",
"0xa7eecae957c9dd1960352e101e42ec5804630390a2f986fa4ddabb8afef4f857",
"0xaa596f8160953f433eafdfaf2cffc3a9d6a47518c9898b7d501f78902d4a609f",
"0xad9f7291063b933a142b04e33f70d6954799afec9d88ea2ed985356f6af80904",
"0xaec6588d1270f0a1b7d354817d3f04a1b3757409fc554afe993f5171a5233e2c",
"0xaf0fa49ab5f25759d0cf96a8019b86259fb49bde6ad1215e05102e2b9f479e2d",
"0xafa5f9a5961c045898c1a671ef667e8656eaaca3e0a2008088e1976727b86461",
"0xb2bf0361ed804fe1e47a223bda820bc32b9187ee201626512534e11e32932a4c",
"0xb301541f84c9d31b8f562df54aa10afa5861b9ff6ebbac9f0140613d270e6c37",
"0xb317a643ee3930ad7f6603ebed4b22c61bd15e146e638e7d61a95fbb2b830614",
"0xb3cc43f0ae615fb91556c3487415e79d417f9a7156a3b8785777f239e597448a",
"0xb457bf3e499594095f57b1ed8dd0dda91d9febbcb91b1bb290f2df8ce42aadc8",
"0xb51af9ff64c788d223ef9d602d77b95c69bcf5faa96f83826ad5b6dc6fa66a31",
"0xb7f24f502d65f6183f9776a4ffac60581bdae393e70a7d33eaece4d6e270f4cb",
"0xb8358456eadc6878c87f75d90c308d0e39c02fc10ae05ee90a0bc85b6ebaf56a",
"0xb8484633a658aaf06de57efea84d579ea87970684385d0488bdef6e19e92e493",
"0xb8c779bc10ee087c8aaf1088ec83a1ddb7024e5ad19a3031ae7cf4e6e70df590",
"0xb8e8ecdf636da749c0e43169acb7dc2e6417d9285d3701021e0b371bb2469b97",
"0xb99e6c38592807260a6462524c10aad759c1e2b8d9822913fce87022fbd67f99",
"0xbacc93801d2f82891be0da6470fc841b66bc0bafcc9bbcecfe8867638fe30fb5",
"0xbb64ae496d0aefd96f0f89befbbe5420af7decb89e46929144c3de206340aced",
"0xbc674cc6d4551a943b3f8b63d01365e4a1762987e12245c8ff62012c16b61429",
"0xbd22e8aede2515a02a187aad809896adf469256ad29a89330c108985819a1d38",
"0xbd2c44bcb7cc61e27cf5067399288c42d099f7330a5445fd89c4a350017fea14",
"0xbd88d72b1b9d5e3d8d22fb1311de460376b16cc5417ea19bc13ac7b91b9d8622",
"0xc3e0c3fc4c44fac0e331b72f9d276ad387c0b2557435a8c56c6cb949da799a13",
"0xc4e484eb5805e9f16d01a99e0e9d86fba2bcd52844727847e988955925f24fe0",
"0xc5195d75bdb587378c14a6f1124c875b47183792ff0784f2c20d1b94f6ff292b",
"0xc67522efe1e0fa5e0314ecef5c4c3fca6e4529c2482eca3a091e59a038d18f46",
"0xc714928988e8a6719fea866b8f47f183f31ebe756fedcd49bcb094a2ed73d6b1",
"0xc7bb4517079284f78c2bb15135067c3337328edaf8b0721fba741f16a1ad7126",
"0xc8026982a3ac5fdc33a4fcec41c25f4182950d5180181c2583979e061ff1464f",
"0xc831f28349113d86344a3940ccc2d4141c898f46f60e5d5ccfcca59776e8b52d",
"0xc9742dc951d9548112c2009d454a937bce4c6bb2b90a989a09def825a2c0a8ac",
"0xcd49a65b6ba01bb2ebc1f86794fa7a8cd587d526d6fd5c079cd3404dffa89b74",
"0xcdb4f8d6fbd61ffee10ab9e0017025828cb944ada261baacf7ffbb40334b0a21",
"0xce8fb2800aa3727466c1fda4b913a95c5171b305dc123978641856c5a735c805",
"0xd0285ebf11a8e3efd4396d0212070eddbe10a98b651ee188b616b187b1554bed",
"0xd28ab0a9e9aeb9115a0ed98c4c2a3fc56353e1aee9229928e53cd79d32ad60d7",
"0xd2cda434b3ba5d4f48d624a1673cb1df8e003a1a0cd8b83207609d1c5a5c3801",
"0xd3a033ed3ba261d421103828fc325aa6e6a46fabc7ba20e9b58ba59ac658e61e",
"0xd6a798f213dbfb85fa1ba01cfaeb3bbfd655c90202d94aeb86c883ba092e8c61",
"0xd6c903fe57e6eafe68d040445a66114f171910aaf47725684563282b00dc7692",
"0xd8b33b8ca027ae2cb1438deb7d2b87ce9734727477795dd7a14924bd382724da",
"0xd8b52cda68b6f7476626256876c26b2de44074171e85225f44439ea719fdbcb8",
"0xd8dc3b932ead6db7e249c4a616541530e8106ed0a33c11a001187ff28a66db69",
"0xd958c3738c7b419bc6004609269131aa055b0a2b0216a7805e95a2aca4ee17d6",
"0xd9df7fb4b5533d539a670279067b0d4b33707d9c25d4c69efe2ba796147f719b",
"0xdcb6df621abac1d85d96f48d47ed1e4284a87f8082d9b587217193f201fd6b9f",
"0xdd5b483d45b5ec9c78559d1ab2e7c7fd6fd70aead70d3a196035786461c91f00",
"0xe004add8d11c6459d309f05212692acf6b0f4ef9836e410e3711c4d8b6ca24af",
"0xe3756c33b32a1d8c529624aec86907f63f46af6102ec1d3ff5fcd37fd5a81618",
"0xe4914f6fe417c3160bf6e453060c9c624294eef82d908124053d610f7665334a",
"0xe5539b148f7499db574ab0fcae5388542fec3fc12136f8e54ab8715e9ca98373",
"0xe609f09a6ca63c482f6100d90de606513eb7bc69345ded0a962ca8ffd66a2d3e",
"0xe71e273676a15ebafe982c0b072cce06f374a141548572a221e0f20fc2e2d7a2",
"0xe7405af2756fb280f02e6763018958b996d3ad992af2f6be291827fd10f030a4",
"0xe7acf770e5494eb340456786ad83bec2a2b32af244a3f8143f43d21703b18a2b",
"0xe7ed0dfa084ede67388897f2acaee6fd64821d32a8ddc0387aa507361767fd1c",
"0xe7f481d696b42db27b4020f778994f3d1b57d4f7b0d5c2609cb6f76a28d795d2",
"0xe9bfe63a04de7c7297c846ee5180834e0569334af439e2464810925818f0544d",
"0xea2286764bfdad011423c479a77f4bf13ab04bc6239df4aa1b985277cbc33722",
"0xeb5cfa60478161f4217a78e07de8cb3e95150f30449375342fe7c26327166aa0",
"0xeb91ca6618dc47522601884ab234bbf293258138f65b4008e2e06c0a255817b7",
"0xebb70ca9c8c71c19616aa1a31207ca7edfeb1e3cf236ef40b9dadab6b09c8c19",
"0xee5726fa217120ddd5643c9231dc32ed47b8146431b204231c4934be267cf11d",
"0xef4cb72d1296568e5da5dc718daa5f61e27e11886894d4201a636368678fd903",
"0xefa58d5afa9bb92a085a0c05090fb1ccce2fd4b99c64a3a6bc99fbd999aacdb1",
"0xf5610d7e26840b3500281b3f03e3944221566fbc1ca8d66835d5481706753f14",
"0xf5b187e1226825f23094fc5008a86fca350409ad82771b6a51ef5ead86e39f26",
"0xf5cca7d80a505870ff4ddab9b17086a6ddb76c6afd0e4a4239b9a7da02cff883",
"0xf70c0d455ba95f25b748fe9be26e18359ad776b143c378f6ab747fc6ffcc25ff",
"0xf72c1ee0ab7c19ce42417982003cec6e98de0c6100acfef883dfcd9cdfd32c33",
"0xf9051064cdd8a81fa197cd3c06b312f917f4c8d0c73e757c73616197d84326d9",
"0xff54e5c1b806030f51fecbd86f5785084a494ebdc6d6acab65dd4f4303f00825"
];
